export const GET_PERIODS_ACTION_REQUEST = 'GET_PERIODS_ACTION_REQUEST';
export const GET_PERIODS_ACTION_SUCCESS = 'GET_PERIODS_ACTION_SUCCESS';
export const GET_PERIODS_ACTION_FAILURE = 'GET_PERIODS_ACTION_FAILURE';

export const GET_PERIODS_ACTION_FETCH = 'GET_PERIODS_ACTION_FETCH';

export const SET_PERIOD_ACTION = 'SET_PERIOD_ACTION';

export const LOCK_PERIOD_ACTION_REQUEST = 'LOCK_PERIOD_ACTION_ACTION_REQUEST';
export const LOCK_PERIOD_ACTION_SUCCESS = 'LOCK_PERIOD_ACTION_ACTION_SUCCESS';
export const LOCK_PERIOD_ACTION_FAILURE = 'LOCK_PERIOD_ACTION_ACTION_FAILURE';
export const LOCK_PERIOD_ACTION = 'LOCK_PERIOD_ACTION';

export const UNLOCK_PERIOD_ACTION_REQUEST = 'UNLOCK_PERIOD_ACTION_ACTION_REQUEST';
export const UNLOCK_PERIOD_ACTION_SUCCESS = 'UNLOCK_PERIOD_ACTION_ACTION_SUCCESS';
export const UNLOCK_PERIOD_ACTION_FAILURE = 'UNLOCK_PERIOD_ACTION_ACTION_FAILURE';
export const UNLOCK_PERIOD_ACTION = 'UNLOCK_PERIOD_ACTION';

export const OPEN_PERIOD_ACTION_REQUEST = 'OPEN_PERIOD_ACTION_ACTION_REQUEST';
export const OPEN_PERIOD_ACTION_SUCCESS = 'OPEN_PERIOD_ACTION_ACTION_SUCCESS';
export const OPEN_PERIOD_ACTION_FAILURE = 'OPEN_PERIOD_ACTION_ACTION_FAILURE';
export const OPEN_PERIOD_ACTION = 'OPEN_PERIOD_ACTION';

export const PERIOD_SEND_NOTIFICATION_CLEAR = 'PERIOD_SEND_NOTIFICATION_CLEAR';
